import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const IS_COVERED_BY_MORTGAGE = {
  YES: 'yes',
  NO: 'no',
} as const;

export const IS_COVERED_BY_MORTGAGE_NAME = 'is_covered_by_mortgage';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupIsCoveredByMortgage: FC<Props> = ({
  name = IS_COVERED_BY_MORTGAGE_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy nieruchomość jest objęta kredytem hipotecznym?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${IS_COVERED_BY_MORTGAGE.YES}`}
                value={IS_COVERED_BY_MORTGAGE.YES}
                label={i18n.t('Tak')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${IS_COVERED_BY_MORTGAGE.NO}`}
                value={IS_COVERED_BY_MORTGAGE.NO}
                label={i18n.t('Nie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
